import React from 'react';
import PropTypes from 'prop-types';

const HtmlPopup = ({ data }) => {
  const generateHtml = () => ({ __html: data });
  return <div dangerouslySetInnerHTML={data && generateHtml()} />;
};

export default HtmlPopup;

HtmlPopup.propTypes = {
  data: PropTypes.string.isRequired
};
